import React, { Component } from 'react';
import { message, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedFooter from '../connectedComponents/ConnectedFooter.js';
import ForgetPassword from './ForgetPassword.js';
import CountUp from 'react-countup';
import { apis } from '../api/index.js';
import './login.css';
import userCountImg from './img/jigou.png';
import dcmCountImg from './img/yinpian.png';
import imgTit from './img/img-tit.png';

import Loading from '../components/Loading/Loading.js';
import LoginByEmail from './LoginByEmail.js';
import LoginByAccount from './LoginByAccount.js';
import { aesMinEncrypt, checkPassword } from '../utils';

class LoginFrom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountName: '',
      password: '',
      tips: '',
      imgCodeUrl: '/ai-web/boxuser/verifyCodeGen',
      btnDisabled: true,
      userCount: 0,
      dcmCount: 0,
      loginType: 'account',
      sendEmailButtonDisabled: true,
      email: '',
      fromExe: false,
      showForgetPassword: false,
    };

    this.userInfo = {};
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
    setMenuOpenList: PropTypes.func,
    clearHeatmapInfo: PropTypes.func,
    clearCurrentInfo: PropTypes.func,
    setCurrentReportTime: PropTypes.func,
    setNationalDict: PropTypes.func,
    setIDTypeDict: PropTypes.func,
    setCardTypeDict: PropTypes.func,
  };

  componentDidMount() {
    this.getCount();
    window.loginForExe = (name, password) => {
      this.loginWithOutVCode(name, password);
    };

    if (typeof _$x !== 'undefined') {
      /*global _$x*/
      /*eslint no-undef: "error"*/
      this.setState({ fromExe: true });
      _$x.UserInfo().then(res => {
        const obj = JSON.parse(res);
        this.loginWithOutVCode(obj.username, obj.password);
      });
    }
    sessionStorage.setItem('isLoadTips', 'false');
  }

  loginWithOutVCode = (name, pwd) => {
    const password = aesMinEncrypt(pwd);

    const post = { accountName: name, password };

    apis.login(post).then(result => {
      this.handleLoginResult(result);
    });
  };
  getProductId = list => {
    let id = '';
    list.map(item => {
      if (!id && item.isAuth) id = item.productId;
      return item;
    });
    return id;
  };

  getCount = () => {
    const user = Promise.resolve(apis.userCount());
    const dcm = Promise.resolve(apis.dicomCount());
    Promise.all([user, dcm]).then(values => {
      this.setState({
        userCount: values[0].data || 0,
        dcmCount: values[1].data || 0,
      });
    });
  };

  handleLoginResult = result => {
    if (result.code === '0') {
      apis.logout4CT();
      this.props.setMenuOpenList([]);
      message.success('登录成功', 2);
      sessionStorage.setItem('isLoadSystemNotice', 'false');
      let userInfo = result.data;

      const mode = checkPassword(userInfo.password);
      if (mode <= 1) userInfo = { ...userInfo, needUpdatePwd: true };
      const oldUserInfo = window.store.getState().api.user.info;
      if (userInfo.id !== oldUserInfo.id) {
        this.props.clearHeatmapInfo();
        this.props.clearCurrentInfo();
      }
      const resType = Promise.resolve(apis.dcm4cheeType());
      const pathRes = Promise.resolve(apis.dcm4cheepath());
      const sysRes = Promise.resolve(apis.sysConfig());
      const national = Promise.resolve(apis.national());
      const IDType = Promise.resolve(apis.IDType());
      const cardType = Promise.resolve(apis.cardType());

      Promise.all([resType, pathRes, sysRes, national, IDType, cardType]).then(
        values => {
          userInfo = {
            ...userInfo,
            dcmType: values[0].type,
            path: values[1].wado,
          };

          this.props.onUserInfoUpdated(userInfo);
          this.props.setCurrentReportTime(values[2].data);

          this.props.setNationalDict(values[3].data);
          this.props.setIDTypeDict(values[4].data);
          this.props.setCardTypeDict(values[5].data);

          let url = '';
          if (result.data.menus[0].childMenus[0].childMenus.length > 0) {
            url = result.data.menus[0].childMenus[0].childMenus[0].menuContent;
          } else {
            url = result.data.menus[0].childMenus[0].menuContent;
          }
          if (['product', 'chart'].includes(url)) {
            let products = result.data.products;
            let productId = this.getProductId(products);
            url = url === 'product' ? 'upload' : 'charts';
            this.props.history.push(`/${url}/${productId}`);
          } else {
            this.props.history.push(url);
          }
        }
      );
    } else {
      message.error(result.message);
    }
  };

  setLoginType = type => {
    this.setState({ loginType: type });
  };

  forgetPasswordVisible = state => {
    this.setState({ showForgetPassword: state });
  };

  render() {
    const { userCount, dcmCount, loginType, fromExe } = this.state;
    const countUpProps = {
      start: 0,
      useEasing: true,
      useGrouping: true,
      duration: 2.75,
      separator: ',',
    };
    if (fromExe) {
      return <Loading />;
    } else {
      return (
        <>
          <div className="login-page-bg">
            <ConnectedHeader login={true} home={true} user={this.props.user} />
            <div className="logoTopBox">
              <img src={imgTit} alt="" />
            </div>
            <div className="login-center">
              <div className="login">
                <div className="login-left">
                  <Row>
                    <Col span={12} className="flexBox">
                      <p>
                        <img src={userCountImg} alt="" />
                      </p>
                      <div>
                        <p className="num">
                          <CountUp
                            className="gmv-show-gmv"
                            end={userCount || 0}
                            // end={91}
                            {...countUpProps}
                          />
                        </p>
                        <p className="name">机构数量</p>
                      </div>
                    </Col>
                    <Col span={12} className="flexBox">
                      <p>
                        <img src={dcmCountImg} alt="" />
                      </p>
                      <div>
                        <p className="num">
                          <CountUp
                            className="gmv-show-gmv"
                            end={dcmCount || 0}
                            // end={8694}
                            {...countUpProps}
                          />
                        </p>
                        <p className="name">影片上传数量</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                {loginType === 'account' ? (
                  <LoginByAccount
                    forgetPasswordVisible={this.forgetPasswordVisible}
                    handleLoginResult={this.handleLoginResult}
                    setLoginType={this.setLoginType}
                  />
                ) : (
                  <LoginByEmail
                    handleLoginResult={this.handleLoginResult}
                    setLoginType={this.setLoginType}
                  />
                )}
              </div>
            </div>
          </div>
          <ConnectedFooter />
          <ForgetPassword
            visible={this.state.showForgetPassword}
            onCancel={this.forgetPasswordVisible.bind(this, false)}
          />
        </>
      );
    }
  }
}

export default withRouter(LoginFrom);
